import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { formatSecondsToTime } from "utils/datetime";
import { FiActivity } from "react-icons/fi";
import { dashboardsService } from "services";
import eventBus, { DASHBOARD_EVENTS } from "utils/eventBus";
import { withTranslation } from "react-i18next";

const summaryRequests = {};

const getHourSummary = (employeeId) => {
	if (!summaryRequests[employeeId]) {
		const request = dashboardsService.getEmployeeHourSummary(employeeId);
		summaryRequests[employeeId] = request;
		request.finally(() => {
			if (summaryRequests[employeeId] === request) delete summaryRequests[employeeId];
		});
	}
	return summaryRequests[employeeId];
};

/** Horas decimales del API → segundos enteros (corrige float) → mismo formato que /my-times. */
function formatHoursFromApi(hours) {
	return formatSecondsToTime(Math.round(Number(hours || 0) * 3600), "hm");
}

class Dashboard_TotalWorkingHours extends Component {
	constructor(props) {
		super(props);
		//  console.log(props);

		this.state = {
			expected_week: 0,
			expected_month: 0,
			expected_year: 0,
			total_week: 0,
			total_month: 0,
			total_year: 0,
		};
	}

	componentDidMount() {
		this.getTotals();
		
		// Suscribirse a eventos de actualización de fichajes
		this.handleTimeRegistrationUpdate = this.handleTimeRegistrationUpdate.bind(this);
		eventBus.on(DASHBOARD_EVENTS.TIME_REGISTRATION_UPDATED, this.handleTimeRegistrationUpdate);
	}

	componentWillUnmount() {
		// Desuscribirse de eventos al desmontar el componente
		eventBus.off(DASHBOARD_EVENTS.TIME_REGISTRATION_UPDATED, this.handleTimeRegistrationUpdate);
	}

	// Manejador para actualizar los datos cuando se actualiza un fichaje
	handleTimeRegistrationUpdate(data) {
		// Solo actualizar si el evento es del usuario actual
		if (data.userId === this.props.user.id) {
			this.getTotals();
		}
	}

	async getTotals() {
		const employee_id = this.props.user.id;
		const resp = await getHourSummary(employee_id);
		// console.log(resp);
		const { current_week, current_month, current_year } = resp;

		this.setState({
			total_week: resp.ok ? current_week.time_registration_hours : 0,
			expected_week: resp.ok ? current_week.target_hours : 0,
			total_month: resp.ok ? current_month.time_registration_hours : 0,
			expected_month: resp.ok ? current_month.target_hours : 0,
			total_year: resp.ok ? current_year.time_registration_hours : 0,
			expected_year: resp.ok ? current_year.target_hours : 0,
		});
	}

	getProgress = (total, expected) =>
		expected > 0 ? Math.min((total / expected) * 100, 100) : 0;

	render() {
		const {
			total_week,
			total_month,
			total_year,
			expected_week,
			expected_month,
			expected_year,
		} = this.state;

		const today = new Date();
		const month = moment(today).format("MMMM");
		const year = today.getFullYear();

		const { t } = this.props;
		const { period } = this.props;

		if (period) {
			const values = {
				week: { total: total_week, expected: expected_week },
				month: { total: total_month, expected: expected_month },
				year: { total: total_year, expected: expected_year },
			}[period];
			const progress = values.expected > 0
				? Math.min((values.total / values.expected) * 100, 100)
				: 0;

			return (
				<div className="working-hours-period">
					<strong className="working-hours-period__value">
						{formatHoursFromApi(values.total)}
					</strong>
					{values.expected > 0 && (
						<span className="working-hours-period__target">
							{t("widgets.totalWorkingHours.of")} {formatHoursFromApi(values.expected)}
						</span>
					)}
					<div className="working-hours-period__progress" aria-hidden="true">
						<span style={{ width: `${progress}%` }} />
					</div>
				</div>
			);
		}

		if (
			total_week > 0 ||
			total_month > 0 ||
			total_year > 0 ||
			expected_year > 0
		) {
			return (
				<>
					<div className="bloque-horas">
						<h4 className="title">{t("widgets.totalWorkingHours.thisWeek")}</h4>
						<span className="horas-trabajadas">
							{formatHoursFromApi(total_week)}
						</span>
						{expected_week > 0 && (
							<span className="horas-teoricas">
								{t("widgets.totalWorkingHours.of")}{" "}
								<span className="horas-teoricas-total">
									{formatHoursFromApi(expected_week)}
								</span>
							</span>
						)}
						<div className="horas-progreso" aria-hidden="true">
							<span style={{ width: `${this.getProgress(total_week, expected_week)}%` }} />
						</div>
					</div>

					<div className="bloque-horas">
						<h4 className="title capitalize">{month}</h4>
						<span className="horas-trabajadas">
							{formatHoursFromApi(total_month)}
						</span>
						{expected_month > 0 && (
							<span className="horas-teoricas">
								{t("widgets.totalWorkingHours.of")}{" "}
								<span className="horas-teoricas-total">
									{formatHoursFromApi(expected_month)}
								</span>
							</span>
						)}
						<div className="horas-progreso" aria-hidden="true">
							<span style={{ width: `${this.getProgress(total_month, expected_month)}%` }} />
						</div>
					</div>

					<div className="bloque-horas">
						<h4 className="title">{year}</h4>
						<span className="horas-trabajadas">
							{formatHoursFromApi(total_year)}
						</span>
						{expected_year > 0 && (
							<span className="horas-teoricas">
								{t("widgets.totalWorkingHours.of")}{" "}
								<span className="horas-teoricas-total">
									{formatHoursFromApi(expected_year)}
								</span>
							</span>
						)}
						<div className="horas-progreso" aria-hidden="true">
							<span style={{ width: `${this.getProgress(total_year, expected_year)}%` }} />
						</div>
					</div>
				</>
			);
		} else {
			return (
				<div className="empty">
					<FiActivity />
					<p>{t("widgets.totalWorkingHours.noData")}</p>
				</div>
			);
		}
	}
}

const mapStateToProps = (reducers) => {
	return {
		user: reducers.authReducer.user,
	};
};

export default connect(mapStateToProps, null)(withTranslation()(Dashboard_TotalWorkingHours));
